import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { UserService } from '../user/user.service';
import { SupportTicketsDialogComponent } from './tickets-dialog.component';
import { UserModel } from '../user/user.model';
import { DummyComponent } from '../../shared/dummy.component';
import { SupportTicketsService } from './tickets.service';
import { SupportTicketsConversationComponent } from './tickets-conversation.component';
import { SupportTicketsModel } from './tickets.model';
import { AdminConst } from '../admin/const';


@Component({
    selector: 'app-supporttickets',
    templateUrl: './tickets.component.html',
    styleUrls: ['./tickets.component.css'],
    standalone: false
})
export class SupportTicketsComponent implements OnInit {

    constructor(
        public dialog: MatDialog,
        private supportTicketsService: SupportTicketsService,
        public dummy: DummyComponent,
        public userService: UserService,
        private router: Router,
    ) { }

    ready = false;
    currentUser: UserModel;
    dataSource: SupportTicketsModel[] = [];
    today = new Date();
    isAdmin: boolean = false;
    headerTable: any[] = AdminConst.headerTableSupportTicket;

    viewTicket(ticketId: number) {
        this.dialog.open(SupportTicketsConversationComponent, {
            //height: '80%',
            // width: '40%',
            data: {
                ticketId: ticketId
            }
        })
    }

    resolveTicket(ticketId: number) {
        this.supportTicketsService.resolveTicket(ticketId).then(response => {
            this.dummy.redirectTo(this.router.url);
        })
    }

    newTicket() {
        this.dialog.open(SupportTicketsDialogComponent, {
            //height: '80%',
            // width: '40%',
            data: {

            }
        })
    }

    ngOnInit() {
        this.userService.loadData().then(userData => {
            this.currentUser = userData;
            this.isAdmin = this.currentUser.isAdmin
            this.ready = true;
        })
        this.supportTicketsService.getListTickets().then(response => {
            this.dataSource = response;
            this.dataSource.sort(function (a, b) {
                const textA = a.id;
                const textB = b.id;
                return (textA > textB) ? -1 : (textA < textB) ? 1 : 0;
            });
        })
    }

  public trackByIndex(i: number) { return i; }

}